var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "uloha-btn",
      class: {
        "uloha-btn--inprogress": _vm.uloha.status === "aktivna",
        "uloha-btn--locked": _vm.uloha.status === "buduca"
      }
    },
    [
      _c("span", {
        staticClass: "status",
        class: {
          "status--done": _vm.isDone,
          "status--open": _vm.isOpen,
          "status--pending": _vm.isPending,
          "status--locked": _vm.isLocked,
          "status--failed": _vm.isFalse
        }
      }),
      _vm._v(" "),
      _c("span", {
        staticClass: "main-icon",
        class: {
          "icon--kviz": _vm.typ === "kvizova",
          "icon--tvoriva": _vm.typ === "tvoriva"
        }
      }),
      _vm._v(" "),
      !_vm.hideProgress
        ? _c(
            "div",
            {
              staticClass: "progress",
              class: {
                "progress--warning": _vm.progress < 80,
                "progress--done": _vm.progress >= 80
              }
            },
            [
              _c("span", {
                staticClass: "progress-bg",
                style: { width: _vm.progress + "%" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "progress-value" }, [
                _vm._v(_vm._s(_vm.progress) + "%")
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isEditable
        ? _c("router-link", {
            staticClass: "stretched-link",
            attrs: {
              to: {
                name: "skoly-ulohy-" + _vm.uloha.typ,
                params: { uloha_id: _vm.uloha.id }
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }